import { formatDateTime, formatList } from '../../i18n/format';
import { i18n } from '../../i18n/i18n';

/** Short weekday name in the active language. Contract: 0 = Sunday … 6 = Saturday. */
export function weekdayLabel(day: number): string {
  // 1 Jan 2023 was a Sunday; noon keeps DST shifts from changing the date.
  return formatDateTime(new Date(2023, 0, 1 + day, 12), { weekday: 'short' });
}

export function formatDaysOfWeek(days: number[]): string {
  if (days.length === 0) return i18n.t('schedule:days.everyDay');
  const unique = [...new Set(days)].sort((a, b) => a - b);
  return formatList(unique.map(weekdayLabel), 'unit');
}
